<template>
  <el-form
    :model="ruleForm2"
    :rules="dynamicRules"
    ref="ruleForm2"
    label-position="left"
    label-width="0px"
    class="demo-ruleForm login-container"
  >
    <h3 class="title">系统登录</h3>
    <el-form-item prop="mobile">
          <el-input
            type="text"
            @keydown.enter.native="handleSubmit2"
            v-model="ruleForm2.mobile"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            @keydown.enter.native="handleSubmit2"
            v-model="ruleForm2.password"
            auto-complete="off"
            placeholder="请输入动态验证码"
          ></el-input>
        </el-form-item>
    <!-- <el-tabs v-model="tabValue" type="border-card" @tab-click='tabHand'>
      <el-tab-pane label="谷歌验证器登录" name='secret'>
        
      </el-tab-pane>
      <el-tab-pane label="账号密码登录" name='password'>
        <el-form-item prop="username">
          <el-input
            type="text"
            @keydown.enter.native="handleSubmit2"
            v-model="ruleForm1.username"
            auto-complete="off"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password2">
          <el-input
            type="password"
            @keydown.enter.native="handleSubmit2"
            v-model="ruleForm1.password2"
            auto-complete="off"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
      </el-tab-pane>
    </el-tabs> -->
    <el-checkbox v-model="checked" checked class="remember"
      >记住密码</el-checkbox
    >
    <el-form-item style="width: 100%">
      <el-button
        type="primary"
        style="width: 100%"
        @click="handleSubmit2"
        :loading="logining"
        >登录</el-button
      >
      <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
    </el-form-item>
  </el-form>
</template>

<script>
//import NProgress from 'nprogress'
import { routes } from '@/routes'
import cookie from 'vue-cookie'
export default {
  data() {
    return {
      logining: false,
      cookie: '',
      ruleForm2: {
        mobile: '',
        password: '',
        grantType: 'secret',
				// password2:'',
				// username:''
      },
			ruleForm1: {
        // mobile: '',
        // password: '',
        //grantType: 'secret',
				password2:'',
				username:''
      },
      rules2: {
        mobile: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入手机号',
          },
          {
            pattern: /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入动态验证码', trigger: 'blur' },
        ],
				password2: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
				password: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
      },
      checked: true,
      mapRoute: [],
			tabValue:'secret'
    }
  },
  methods: {
    handleReset2() {
      this.$refs.ruleForm2.resetFields()
    },
    convertTree(tree, map) {
      //遍历数组
      // let result = []
      // 遍历 tree
      tree.forEach((item) => {
        // 读取 map 的键值映射
        let children = item[map.children]
        // 如果有子节点，递归
        if (children && children.length > 0) {
          children = this.convertTree(children, map)
        }
        if (item.url) {
          this.mapRoute.push({
            // children,
            title: item.funcName,
            path: item.url,
          })
        }
      })
      // return result
    },
    convertAuthor(tree, userRoute) {
      //1，所有路由表，2接口获取的初始化路由，路由筛选
      // 遍历 tree
      let result = []
      tree.forEach((item) => {
        let children = item.children
        if (children && children.length > 0) {
          children = this.convertAuthor(children, userRoute)
        }
        if (item.redirect) {
          result.push(item)
        }
        userRoute.forEach((rt) => {
          if (rt.path == item.path) {
            result.push({
              ...item,
            })
          }
        })
      })
      return result
    },
    handleSubmit2(ev) {
			var _this = this
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {		
          this.logining = true
          var loginParams = {
            userName: this.ruleForm2.mobile,
            password: this.ruleForm2.password,
            grantType: this.ruleForm2.grantType,
          }
          _this.$author.login(loginParams).then((res) => {
            if (res.result == '00000000') {
              sessionStorage.setItem('user', JSON.stringify(res.data.user)) // 用户信息
              localStorage.setItem('user', JSON.stringify(res.data.user.token)) // 用户信息
              _this.$cookie.set(
                'userToken',
                JSON.stringify(res.data.user.token)
              ) //权限的

              sessionStorage.setItem('authorityInfo', JSON.stringify(res.data)) // 权限信息
              const menuList = res.data.menuList
              const setMenuList = res.data.setMenuList
              sessionStorage.setItem('menuList', JSON.stringify(menuList))
              if (setMenuList != '') {
                //用来判断设置 显示还是不显示
                sessionStorage.setItem(
                  'setMenuList',
                  JSON.stringify(setMenuList)
                )
              }
              // this.$store.commit('SET_ROUTES', menuList)
              this.$router.push({ path: '/homePage' })
            } else {
              _this.$message({ message: res.msg, type: 'error' })
              _this.logining = false
            }
          })
        } else {
          return false
        }
      })
    },
		//切换登录方式
		tabHand(tab,event){
			if(tab.name == 'password'){//账号密码登录

			}else{

			}
		}
  },
	computed:{
		dynamicRules() {
			return this.tabValue ===  'password' ? this.rule1: this.rule2;
		}
	}
}
</script>

<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 24px 0px 35px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?26b870ac